import { ProductsListSortMode } from '@domains/products-catalog';

export const sortModes = [
    ProductsListSortMode.Novelty,
    ProductsListSortMode.Popularity,
    ProductsListSortMode.PriceAscending,
    ProductsListSortMode.PriceDescending,
    ProductsListSortMode.Relevance,
    ProductsListSortMode.NameAscending,
    ProductsListSortMode.NameDescending,
];

export type SortingSelectItem = {
    id: string;
    label: string;
};

export const sortingSelectItems: SortingSelectItem[] = [
    {
        id: ProductsListSortMode.Popularity,
        label: 'Сначала популярные',
    },
    {
        id: ProductsListSortMode.Novelty,
        label: 'Сначала новые',
    },
    {
        id: ProductsListSortMode.PriceAscending,
        label: 'По возрастанию цены',
    },
    {
        id: ProductsListSortMode.PriceDescending,
        label: 'По убыванию цены',
    },
    {
        id: ProductsListSortMode.NameAscending,
        label: 'По алфавиту А-Я',
    },
    {
        id: ProductsListSortMode.NameDescending,
        label: 'По алфавиту Я-А',
    },
];

export const searchSortingSelectItems = [
    {
        id: ProductsListSortMode.Relevance,
        label: 'По релевантности',
    },
    ...sortingSelectItems,
];

export const minSearchQueryLength = 3;
export const pageSize = 24;
export const pageSizePerFive = 25;
export const defaultPage = 1;
export const defaultSearchLimit = 10;
